import { createFileRoute } from "@tanstack/react-router";

import Audit from "~/pages/UsdaAudit/Audit";
import { ROUTE_STATIC } from "~/utils/routeStaticData";

export const Route = createFileRoute("/_private/usda-audit/audit")({
  staticData: ROUTE_STATIC.usdaAudit,
  component: Audit,
});
